export const shouldForwardProp = (propName: string) => {
  return propName !== 'as' && propName !== 'theme' && !propName.startsWith('$')
}
